import React from "react"

export default function Behance() {
  return (
    <svg
      width="29"
      height="18"
      viewBox="0 0 29 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.975 12.1871C14.975 10.0313 13.9495 8.43775 11.8311 7.84047C13.3768 7.10437 14.1829 5.98914 14.1829 4.25446C14.1829 0.834093 11.6258 0 8.67551 0H0.552734V17.173H8.90299C12.034 17.173 14.975 15.6763 14.975 12.1871ZM4.3394 2.93157H7.89275C9.25879 2.93157 10.4884 3.31421 10.4884 4.89373C10.4884 6.35194 9.53177 6.93872 8.17856 6.93872H4.3394V2.93157ZM4.33823 14.2566V9.52732H8.46553C10.1326 9.52732 11.1871 10.2203 11.1871 11.9794C11.1871 13.7141 9.9284 14.2566 8.38737 14.2566H4.33823Z"
        fill="#3870DE"
      />
      <path
        d="M22.6315 16.9755C25.6109 16.9755 27.5404 15.6375 28.469 12.7934H25.4452C25.1198 13.855 23.7782 14.4161 22.7376 14.4161C20.73 14.4161 19.6754 13.2437 19.6754 11.2512H28.6731C28.9578 7.26392 26.7366 3.86572 22.6303 3.86572C18.8285 3.86572 16.248 6.71447 16.248 10.4463C16.248 14.3193 18.6932 16.9755 22.6315 16.9755ZM22.5242 6.44616C24.2448 6.44616 25.1104 7.45407 25.2551 9.10242H19.6801C19.7932 7.46806 20.8816 6.44616 22.5242 6.44616Z"
        fill="#3870DE"
      />
      <path
        d="M18.9805 0.901611H25.9659V2.59314H18.9805V0.901611Z"
        fill="#3870DE"
      />
    </svg>
  )
}
